exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Layout__Layout--1WKx0{\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.Layout__Layout--1WKx0 main{\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n}", ""]);

// exports
exports.locals = {
	"Layout": "Layout__Layout--1WKx0"
};